import { GET } from "~/api/_common/http"

import { defineFetcher } from "../_common/defineFetcher"
import { Application } from "./_types"

export type { Application }

export type GetApplications = Application[]

export const fetchGetApplications = defineFetcher((): Promise<GetApplications> => {
  return GET("/applications")
})
